import { useNavigate } from "react-router-dom";
import { Building2, ArrowRight, ClipboardList, CheckCircle } from "lucide-react";

export default function EmployerSurveyCard({ id, title, description, code, targetGroup, active }) {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate(`/inquerito/${id}`);
    };

    return (
        <div className="bg-gradient-to-r from-emerald-50/30 to-gray-50/30 rounded-xl border border-emerald-100/30 p-6 hover:shadow-md transition-all duration-300">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <div className="flex items-start gap-4 flex-1">
                    <div className="flex-shrink-0">
                        <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center">
                            <Building2 className="w-6 h-6 text-emerald-600" />
                        </div>
                    </div>
                    <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                            <h3 className="text-base font-medium text-gray-800">
                                {title || "Inquérito para Empregadores"}
                            </h3>
                        </div>
                        <p className="text-sm text-gray-500 max-w-md">
                            {description || "Contribua para o alinhamento da formação académica com as necessidades do mercado de trabalho"}
                        </p>
                        {code && (
                            <p className="text-xs text-gray-400 mt-2">
                                Código: {code}
                            </p>
                        )}
                    </div>
                </div>
                <button
                    onClick={handleClick}
                    disabled={!active}
                    className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-medium transition-colors shadow-sm whitespace-nowrap ${
                        active 
                            ? "bg-emerald-600 hover:bg-emerald-700 text-white cursor-pointer" 
                            : "bg-gray-100 text-gray-400 cursor-not-allowed"
                    }`}
                >
                    <ClipboardList className="w-4 h-4" />
                    {active ? "Preencher Inquérito" : "Indisponível"}
                    {active && <ArrowRight className="w-4 h-4" />}
                </button>
            </div>
        </div>
    );
}